import React, { useState } from 'react';
import Dropzone from 'react-dropzone';
import { toast } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import Modal from '../../../../components/modal';
import styles from '../../../Badging/badging.module.scss';
import PulpoField from '../../../../pulpo_visualizer/fields';
import Clickable from '../../../../components/clickable/Clickable';
import FileSlider from '../../../../components/photoCarousel/FileSlider';
import { checkMultiFilesValidation, docFileExtensions, imageFileExtensions } from '../../../../utils/helpers';
import Spinner from '../../../../components/spinner';

const ReqAttachments = (props) => {
  const { attachments, handleAnswerChanged, id: key, handleRemove,
    required: isRequired, handleFieldErrorChanged, showFieldErrors,
    attachmentName, dateDetails, adpAnswers, handleDateChange,
    handleAutoUploadAttachments, entityName, getLoadingStatus, handleAttachmentFailedAlert } = props;

  const [openModal, setOpenModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [load, setLoad] = useState(false);

  const handleRemoveImage = (r) => {
    const res = attachments.filter(e => e !== r);
    handleRemove(r); // to remove from attachments when using req_attachments
    handleAnswerChanged(res, key);
    if (res.length === 0) handleFieldErrorChanged(key, isRequired);
  };

  const handleDrop = (dropped) => {
    if (!checkMultiFilesValidation(dropped, `${imageFileExtensions} , ${docFileExtensions}`)) return;
    const list = attachments || [];
    handleAnswerChanged([...list, ...dropped], key);
    handleFieldErrorChanged(key, false);
  };
  const handleAutoDrop = async (dropped) => {
    const validExtensions = `${imageFileExtensions}, ${docFileExtensions}`;
    if (!checkMultiFilesValidation(dropped, validExtensions)) return;
    const list = attachments || [];
    setLoad(true);
    if (getLoadingStatus) getLoadingStatus(true);
    try {
      let updatedAttachments = [];
      if (handleAutoUploadAttachments) {
        try {
          const attachmentIds = await handleAutoUploadAttachments(dropped, entityName);
          if (!attachmentIds.length) {
            if (typeof handleAttachmentFailedAlert === 'function') {
              handleAttachmentFailedAlert(true);
            }
            return;
          }
          updatedAttachments = dropped.map((file, i) => ({
            name: file.name,
            type: file.type,
            size: file.size,
            lastModified: file.lastModified,
            preview: file.preview,
            attachment_id: attachmentIds[i],
            rawFile: file
          }));
        } catch (uploadError) {
          toast.error('Failed to upload some files. Please try again.');
          return; // Stop processing further
        }
      }
      handleAnswerChanged([...list, ...updatedAttachments], key);
      handleFieldErrorChanged(key, false);
    } catch (error) {
      toast.error('An unexpected error occurred while processing your files. Please try again.');
    } finally {
      setLoad(false);
      if (getLoadingStatus) getLoadingStatus(false);
    }
  };

  const handleOpenModal = (image) => {
    setSelectedImage(image);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };
  return (
    <div
      className={styles.gridContainer}
      style={{
        display: 'grid',
        gridTemplateAreas: `
          "a-left a-right"
          "b-row a-right"
        `,
        gridTemplateRows: 'auto auto',
        gridTemplateColumns: '5fr 3fr',
        borderTop: '1px solid #e6eaee',
        padding: '10px 0'
      }}
    >
      {/* A-Left (area for attachment name) */}
      <div style={{ gridArea: 'a-left' }}>
        <div className={styles.attachmentName}>
          <span>*</span>
          <FormattedMessage
            id=" "
            defaultMessage={attachmentName}
            tagName="p"
          />
        </div>
      </div>

      {/* A-Right (shared area for attachments) */}
      <div style={{ gridArea: 'a-right' }}>
        {attachments?.length > 0 ? (
          attachments.map(e => (
            <div key={e?.file_name || e?.name} className={styles.requiredStyle}>
              <Clickable
                key={e?.id}
                onClick={() => handleOpenModal(e)}
                className={`${styles.addLink}`}
              >
                {e?.file_name ?? e?.name}
              </Clickable>
              <Clickable
                onClick={() => handleRemoveImage(e)}
                className={styles.closeIcon}
              >
                &times;
              </Clickable>
            </div>
          ))
        ) : (
          <div>
            <Dropzone
              onDrop={handleAutoUploadAttachments ? handleAutoDrop : handleDrop}
              disableClick
              className={styles.uploadBtn}
            >
              {({ open }) => (
                <p>
                  <button
                    type="button"
                    onClick={() => open()}
                    className={
                      load
                        ? `${styles.upload} ${styles.disableUpload}`
                        : styles.upload
                    }
                    disabled={load}
                  >
                    <FormattedMessage id="airport.logo.butto" defaultMessage="Upload" />
                  </button>
                  <Spinner active={load} />
                </p>
              )}
            </Dropzone>
            {showFieldErrors && isRequired && (
              <small style={{ color: 'red' }}>
                {(!attachments || attachments.length === 0) && (
                  <FormattedMessage
                    id="pulpoforms.errors.not_blank"
                    defaultMessage="This field cannot be empty"
                  />
                )}
              </small>
            )}
          </div>
        )}
      </div>

      {/* B Row (area for expiry date) */}
      {dateDetails.showDateField && (
        <div style={{ gridArea: 'b-row', display: 'flex', width: 'fit-content' }}>
          <PulpoField
            key="date"
            id="date"
            type="date"
            translationID="puplpofield.expiry.date"
            title="Expiry Date"
            className={styles.marginBottom}
            isRequired
            adp
            handleValueChange={handleDateChange}
            answer={
              adpAnswers?.req_attachments_details?.req_attachments_dates?.[
                `${dateDetails.attachmentName}_date`
              ]
            }
            handleFieldErrorChanged={handleFieldErrorChanged}
          />
        </div>
      )}

      {/* Modal */}
      <Modal
        showIn={openModal}
        onClose={handleCloseModal}
        contentStyles={{
          overflow: 'visible',
          background: '#E6EAEE',
          padding: '20px 40px'
        }}
        width="943px"
        minHeight="100px"
      >
        <FileSlider photos={[selectedImage]} />
      </Modal>
    </div>
  );
};

export default ReqAttachments;
